import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import getters from "./getters";

import _store from "store";
import { merge, extend } from "lodash";

import Vue from "vue";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context(
  "./modules", // directory
  true, // useSubdirectories = true
  /\.js$/ // regExp = /^\.\/.*$/
);

/**
 * 不需要执行`import app from './module/app'`，
 * 以下方法可自动引入moudules文件夹的所有vuex模块
 */
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

const store = new Vuex.Store({
  mutations: {
    RESET_ALL_STATE(state, payload) {
      if (payload instanceof Object === false) {
        // 验证传入的是一个数组
        return;
      }
      const initState = _store.get("initState"); // 取出初始值的缓存
      const _initState = Object.keys(payload).length
        ? merge(initState, payload)
        : initState; // 判断传入值有无数据，有数据更新相对应的值
      extend(state, _initState);
    }
  },
  actions: {
    resetAllState({ commit }, payload = []) {
      commit("RESET_ALL_STATE", payload);
    }
  },
  modules,
  getters,
  plugins: debug ? [createLogger()] : []
});

export default store;
